import { createFileRoute } from '@tanstack/react-router';

import { requireOnboarding } from '../../features/onboarding/require-onboarding';
import { ResearchInterestSettingsPanel } from '../../features/profile/research-interest-settings-panel';

/** S19 — 계정 영역에서 온보딩이 필요한 유일한 화면이다 (D79 · D146 ③). */
export const Route = createFileRoute('/account/research-interests')({
  beforeLoad: ({ context, location }) =>
    requireOnboarding({ queryClient: context.queryClient, location }),
  component: ResearchInterestSettingsPanel,
});
